import React, { useState } from "react";
import { useLocation } from "@reach/router";
import loadable from "@loadable/component";

import SplashText from "../../components/SplashText";
import useMediaQuery from "../../hooks/use-media-query";
import { breakpoints } from "../../../theme";
import {
  Section,
  Heading,
  BlogListStack,
  BlogPostsGrid,
  StyledButton,
  ComingSoonText,
} from "./styles";
import BlogCardsSkeleton from "./blog-cards-skeleton";

const BlogCards = loadable(() => import("./blog-cards"));

const BlogSection = ({
  blogPosts,
  title = "Blog",
  compensateHeaderGap = false,
}) => {
  const { pathname } = useLocation();
  const isHomepage = pathname === "/";
  const isLinksPage = pathname === "/links";
  const cardVariant = isLinksPage ? "wide" : "normal";
  const [showAll, setShowAll] = useState(false);

  const isSmallDesktop = useMediaQuery(
    `(min-width: ${breakpoints.desktop}) and (max-width: 1260px)`,
  );

  const isVeryLargeDesktop = useMediaQuery("(min-width: 2000px)");

  const previewLimit = () => {
    if (isSmallDesktop || isVeryLargeDesktop) {
      return 4;
    }
    return 3;
  };

  const visibleCount =
    !isHomepage || showAll ? blogPosts.length : previewLimit();

  const shouldViewAllRender =
    isHomepage &&
    !showAll &&
    blogPosts.length !== 0 &&
    blogPosts.length > previewLimit();

  const visiblePosts = blogPosts.slice(0, visibleCount);
  const isEmpty = blogPosts.length === 0;

  return (
    <Section
      name="blog"
      as="section"
      $flushBottom={isLinksPage}
      $compensateHeaderGap={compensateHeaderGap}
    >
      <Heading as={compensateHeaderGap || !isHomepage ? "h1" : "h2"}>
        <SplashText variant="accent">{title}</SplashText>
      </Heading>
      <BlogListStack $hasViewAll={shouldViewAllRender}>
        {isEmpty ? (
          <BlogPostsGrid isEmpty variant={cardVariant}>
            <ComingSoonText>📝 Coming Soon! </ComingSoonText>
          </BlogPostsGrid>
        ) : (
          <BlogCards
            fallback={
              <BlogCardsSkeleton
                count={visibleCount}
                variant={cardVariant}
              />
            }
            posts={visiblePosts}
            variant={cardVariant}
          />
        )}
        {shouldViewAllRender && (
          <StyledButton type="button" onClick={() => setShowAll(true)}>
            View All
          </StyledButton>
        )}
      </BlogListStack>
    </Section>
  );
};

export default BlogSection;
